<div
  class="no-data-found d-flex flex-column align-items-center justify-content-center"
>
  <img
    class="mb-4"
    src="https://media.umangapp.in/cdn/landing/no-data-found.svg"
    alt="no-data-found"
    width="128"
    height="100"
    loading="lazy"
    fetchpriority="high"
    
  />
  <h5>{{ message | translate }}</h5>
</div>
